<style lang="scss" scoped>
.job-card {
    @apply bg-light rounded-sm flex flex-col;
    // general
    header {
        @apply flex mb-16;
        .function {
            @apply text-dark font-dm font-bold;
            width: calc(100% - 23px - 17px);
            word-break: break-word;
            -moz-hyphens: manual;
            -ms-hyphens: manual;
            hyphens: manual;
        }
        .like {
            @apply hover:fill-green hover:stroke-green transition-colors;
            margin-top: 11px;
            margin-left: 23px;
            width: 17px;
            display: block;
            ::v-deep svg {
                width: 100%;
            }
            &:not(.liked) {
                @apply stroke-gray fill-transparent;
            }
            &.liked {
                @apply fill-green stroke-green;
            }
        }
    }
    .label {
        @apply bg-green border-green text-tiny inline-block px-4 pt-2 pb-1 text-white border-l-2 border-r-2 rounded-sm;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 75%;
        @media (min-width: 1024px) {
            max-width: 85%;
        }
    }
    // size specifics
    &.large {
        @apply p-24 lg:p-40;
        height: 252px;
        @media (min-width: 1024px) {
            height: 325px;
        }
        header {
            .function {
                @apply text-h5 lg:text-32;
            }
        }
    }
    &:not(.large) {
        @apply p-24;
        height: 252px;
        @media (min-width: 1024px) {
            height: 266px;
        }
        header {
            .function {
                @apply text-h5 lg:text-h4;
            }
        }
    }
}
.date {
    font-size: 0.625rem;
    line-height: 0.8125rem;
    @apply uppercase text-gray font-bold font-dm;
}
</style>

<template>
    <div class="job-card cursor-pointer" @click.stop="goToJob()">
        <header>
            <v-clamp autoresize :max-lines="2" class="function">{{ job.title.rendered }}</v-clamp>
            <span class="like" :class="{ liked: $root.favorites.includes(job.id) }" @click.stop="$root.iLikeThis(job.id)" v-html="svg('heart')"></span>
        </header>
        <div class="mb-24" v-if="job.sector_objects && job.sector_objects.length">
            <span v-for="sector in job.sector_objects" class="label" v-html="sector.name"></span>
        </div>
        <div class="flex items-center mb-8" v-if="job.acf.location">
            <span v-html="svg('map-pin', 'w-12 h-12 stroke-green')"></span>
            <span class="font-dm text-small opacity-90 text-dark ml-8 font-bold" v-html="job.acf.location.city"></span>
        </div>
        <div class="flex items-center mb-auto" v-if="job.contract_type_objects && job.sector_objects.length">
            <template v-for="contract_type in job.contract_type_objects">
                <span v-html="svg('file', 'w-12 h-12 stroke-green')"></span>
                <span class="font-dm text-small opacity-90 text-dark ml-8 font-bold" v-html="contract_type.name"></span>
            </template>
        </div>
        <div class="date" v-html="dateLabel"></div>
    </div>
</template>

<script>
import { formatDistanceToNowStrict } from "date-fns";
import { nl } from "date-fns/locale";
import VClamp from "vue-clamp";

export default {
    components: {
        VClamp,
    },

    props: {
        job: {
            type: Object,
            required: true,
        },
    },

    computed: {
        dateLabel() {
            return `${formatDistanceToNowStrict(new Date(this.job.date.replace(/ /g, "T")), { addSuffix: true, locale: nl })} gepubliceerd`;
        },
    },
    methods: {
        goToJob() {
            window.location.assign(`/jobs/${this.job.slug}`);
        },
    },
};
</script>
